<main class="main">
  <div class="content">
    <div class="left-side" *ngIf="!isPreview">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <div>2xProperty Destination Name</div>
        <div class="remove-block-button">
          <a class="btn btn-sm" (click)="removeBlock()"
            ><i class="bi bi-trash-fill remove-block-icon"></i
          ></a>
        </div>
      </div>
      <div class="row align-items-center">
        <div class="col-6">
          <app-block-text
            [maxLength]="500"
            [type]="'link'"
            (handleOnChange)="onChange($event, 'X2PropRec1Image')"
            [blockData]="block.variables?.X2PropRec1Image ?? ''"
            [placeholder]="image1Placeholder"
            variable="X2PropRec1Image"
            [isImage]="true"
            [blockId]="block.blockId"
          ></app-block-text>
        </div>
        <div class="col-6">
          <app-block-text
            [type]="'link'"
            [maxLength]="500"
            (handleOnChange)="onChange($event, 'X2PropRec2Image')"
            [blockData]="block.variables?.X2PropRec2Image ?? ''"
            [placeholder]="image2Placeholder"
            variable="X2PropRec2Image"
            [isImage]="true"
            [blockId]="block.blockId"
          ></app-block-text>
        </div>
        <div class="col-3">
          <app-block-text
            [type]="'action-link'"
            [maxLength]="500"
            (handleOnChange)="onChange($event, 'X2PropRec1ImageHref')"
            [blockData]="block.variables?.X2PropRec1ImageHref ?? ''"
            [placeholder]="image1HrefPlaceholder"
            variable="X2PropRec1ImageHref"
            (handleOnSegmentChange)="handleOnSegmentChange($event, 'X2PropRec1ImageHrefSegmentRegex')"
            [selectedSegment]="block.variables?.X2PropRec1ImageHrefSegmentRegex ?? ''"
          ></app-block-text>
        </div>
        <div class="col-3">
          <app-block-text
            [type]="'action-link'"
            [maxLength]="500"
            (handleOnChange)="onChange($event, 'X2PropRec2ImageHref')"
            [blockData]="block.variables?.X2PropRec2ImageHref ?? ''"
            [placeholder]="image2HrefPlaceholder"
            variable="X2PropRec2ImageHref"
            (handleOnSegmentChange)="handleOnSegmentChange($event, 'X2PropRec2ImageHrefSegmentRegex')"
            [selectedSegment]="block.variables?.X2PropRec2ImageHrefSegmentRegex ?? ''"
          ></app-block-text>
        </div>

        <div class="col-3">
          <app-block-text
            [type]="'alt'"
            [maxLength]="500"
            (handleOnChange)="onChange($event, 'X2PropRec1ImageAlt')"
            [blockData]="block.variables?.X2PropRec1ImageAlt ?? ''"
            [placeholder]="image1AltPlaceholder"
            variable="X2PropRec1ImageAlt"
          ></app-block-text>
        </div>
        <div class="col-3">
          <app-block-text
            [type]="'alt'"
            [maxLength]="500"
            (handleOnChange)="onChange($event, 'X2PropRec2ImageAlt')"
            [blockData]="block.variables?.X2PropRec2ImageAlt ?? ''"
            [placeholder]="image2AltPlaceholder"
            variable="X2PropRec2ImageAlt"
          ></app-block-text>
        </div>
        <div class="col-3">
          <app-block-text
            [type]="'content'"
            [maxLength]="500"
            (handleOnChange)="onChange($event, 'X2PropRec1Name')"
            [blockData]="block.variables?.X2PropRec1Name ?? ''"
            [placeholder]="name1Placeholder"
            variable="X2PropRec1Name"
          ></app-block-text>
        </div>
        <div class="col-3">
          <app-block-text
            [type]="'content'"
            [maxLength]="500"
            (handleOnChange)="onChange($event, 'X2PropRec2Name')"
            [blockData]="block.variables?.X2PropRec2Name ?? ''"
            [placeholder]="name2Placeholder"
            variable="X2PropRec2Name"
          ></app-block-text>
        </div>

        <div class="col-3">
          <app-block-text
            [type]="'content'"
            [maxLength]="500"
            (handleOnChange)="onChange($event, 'X2PropRec1Destination')"
            [blockData]="block.variables?.X2PropRec1Destination ?? ''"
            [placeholder]="destination1Placeholder"
            variable="X2PropRec1Destination"
          ></app-block-text>
        </div>
        <div class="col-3">
          <app-block-text
            [maxLength]="500"
            [type]="'content'"
            (handleOnChange)="onChange($event, 'X2PropRec2Destination')"
            [blockData]="block.variables?.X2PropRec2Destination ?? ''"
            [placeholder]="destination2Placeholder"
            variable="X2PropRec2Destination"
          ></app-block-text>
        </div>

        <div class="col-3">
          <app-block-text
            [maxLength]="500"
            [type]="'action-link'"
            (handleOnChange)="onChange($event, 'X2PropRec1CtaLink')"
            [blockData]="block.variables?.X2PropRec1CtaLink ?? ''"
            [placeholder]="ctaLink1Placeholder"
            variable="X2PropRec1CtaLink"
            (handleOnSegmentChange)="handleOnSegmentChange($event, 'X2PropRec1CtaLinkSegmentRegex')"
            [selectedSegment]="block.variables?.X2PropRec1CtaLinkSegmentRegex ?? ''"
          ></app-block-text>
        </div>
        <div class="col-3">
          <app-block-text
            [type]="'action-link'"
            [maxLength]="500"
            (handleOnChange)="onChange($event, 'X2PropRec2CtaLink')"
            [blockData]="block.variables?.X2PropRec2CtaLink ?? ''"
            [placeholder]="ctaLink2Placeholder"
            variable="X2PropRec2CtaLink"
            (handleOnSegmentChange)="handleOnSegmentChange($event, 'X2PropRec2CtaLinkSegmentRegex')"
            [selectedSegment]="block.variables?.X2PropRec2CtaLinkSegmentRegex ?? ''"
          ></app-block-text>
        </div>

        <div class="col-3">
          <app-block-text
            [type]="'content'"
            (handleOnChange)="onChange($event, 'X2PropRec1CtaText')"
            [blockData]="block.variables?.X2PropRec1CtaText ?? ''"
            [placeholder]="ctaText1Placeholder"
            variable="X2PropRec1CtaText"
            [maxLength]="30"
          ></app-block-text>
        </div>
        <div class="col-3">
          <app-block-text
            [type]="'content'"
            (handleOnChange)="onChange($event, 'X2PropRec2CtaText')"
            [blockData]="block.variables?.X2PropRec2CtaText ?? ''"
            [placeholder]="ctaText2Placeholder"
            variable="X2PropRec2CtaText"
            [maxLength]="30"
          ></app-block-text>
        </div>
      </div>
    </div>
    <div
      class="right-side-container"
      [id]="block.blockId"
      (click)="onContainerClick($event)"
    >
      <app-pin [block]="block"></app-pin>
      <div class="right-side">
        <div class="row text-center">
          <div class="col-6" *ngIf="block.variables?.X2PropRec1Image">
            <a
              target="_blank"
              [href]="helper.getFullUrl($safeNavigationMigration(block.variables?.X2PropRec1ImageHref))"
              ><img
                [src]="$safeNavigationMigration(block.variables?.X2PropRec1Image)"
                class="img-fluid"
                [alt]="$safeNavigationMigration(block.variables?.X2PropRec1ImageAlt)"
            /></a>
          </div>
          <div class="col-6" *ngIf="block.variables?.X2PropRec2Image">
            <a
              target="_blank"
              [href]="helper.getFullUrl($safeNavigationMigration(block.variables?.X2PropRec2ImageHref))"
              ><img
                [src]="$safeNavigationMigration(block.variables?.X2PropRec2Image)"
                class="img-fluid"
                [alt]="$safeNavigationMigration(block.variables?.X2PropRec2ImageAlt)"
            /></a>
          </div>
        </div>
        <div class="row text-left mt-2">
          <div class="col-6">
            <p [innerHTML]="$safeNavigationMigration(block.variables?.X2PropRec1Name)"></p>
          </div>
          <div class="col-6">
            <p [innerHTML]="$safeNavigationMigration(block.variables?.X2PropRec2Name)"></p>
          </div>
        </div>
        <div class="row text-left mt-2">
          <div class="col-6">
            <p [innerHTML]="$safeNavigationMigration(block.variables?.X2PropRec1Destination)"></p>
          </div>
          <div class="col-6">
            <p [innerHTML]="$safeNavigationMigration(block.variables?.X2PropRec2Destination)"></p>
          </div>
        </div>
        <div class="row text-left mt-2">
          <div class="col-6">
            <a
              class="btn btn-primary"
              [href]="$safeNavigationMigration(block.variables?.X2PropRec1CtaLink)"
              target="_blank"
              *ngIf="block.variables?.X2PropRec1CtaLink"
              [innerHTML]="$safeNavigationMigration(block.variables?.X2PropRec1CtaText)"
            ></a>
          </div>
          <div class="col-6">
            <a
              class="btn btn-primary"
              [href]="$safeNavigationMigration(block.variables?.X2PropRec2CtaLink)"
              target="_blank"
              *ngIf="block.variables?.X2PropRec2CtaLink"
              [innerHTML]="$safeNavigationMigration(block.variables?.X2PropRec2CtaText)"
            ></a>
          </div>
        </div>
      </div>
    </div>
    <div class="comments-side" *ngIf="!isPreview">
      <app-notification
        [notifications]="block.notifications"
        [blockId]="block.blockId"
      ></app-notification>
    </div>
  </div>
</main>
